import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { FadeAnimation } from '@app/core/animations/fade.transition';
import { GlobalFiltersState } from '@app/core/store/states/global-filters/global-filters.state';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';
import { SelectorTranslationTexts } from '../../models/selector.model';
import { CriteriaSelectorService } from '../../services/criteria-selector.service';
import { BaseGlobalSelectorComponent } from '../base-global-selector/base-global-selector.component';

@Component({
  standalone: false,
  selector: 'adspt-criteria-selector',
  templateUrl: './criteria-selector.component.html',
  styleUrls: ['./criteria-selector.component.scss'],
  animations: [FadeAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CriteriaSelectorService],
})
export class CriteriaSelectorComponent extends BaseGlobalSelectorComponent {
  heapInfo = {
    search: 'criteria-global-search',
    switch: 'criteria-global-filter-switch',
    item: 'criteria-global-select',
    reset: 'criteria-global-reset-filter',
    apply: 'criteria-global-apply-filter',
  };
  translations$: Observable<SelectorTranslationTexts> = this.translate.get('global-filter.criteria-selector').pipe(
    map((values) => ({
      title: values.placeholder,
      search: values.search,
      all: values.all,
      selected: values.selected,
      notSelectable: values['not-selectable'],
      applyTooltip: values['apply-filters-tooltip'],
    })),
  );
  hasSrcQuery$ = this.store.select(GlobalFiltersState.hasCriteriaQuery);

  constructor(
    private store: Store,
    service: CriteriaSelectorService,
    translate: TranslateService,
    cd: ChangeDetectorRef,
  ) {
    super(service, translate, cd);
  }
}
